import { useMemo } from 'react';

// Our Components
import DynamicTabs from 'components/Tabs/DynamicTabs';
import ReviewKeyActions from 'components/Table/KeyActions/ReviewKeyActions';
import SentKeyActions from 'components/Table/KeyActions/SentKeyActions';
import ArchivedKeyActions from 'components/Table/KeyActions/ArchivedKeyActions';

const TABS_NAMES = [{ type: 'Review' }, { type: 'Sent' }, { type: 'Archived' }];

function KeyActionTabs({ tabPanelSelected, handleTabSelection }) {
	const tabPanelItems = useMemo(() => {
		return [
			{
				children: <ReviewKeyActions />
			},
			{
				children: <SentKeyActions />
			},
			{
				children: <ArchivedKeyActions />
			}
		];
	}, []);

	return (
		<DynamicTabs
			tabItems={TABS_NAMES}
			tabItemSX={{
				padding: 0,
				textTransform: 'none',
				marginRight: 5
			}}
			tabsSX={{
				marginBottom: 4
			}}
			tabPanelItems={tabPanelItems}
			value={tabPanelSelected}
			handleChange={handleTabSelection}
			aria-label="Settings tabs"
		/>
	);
}

export default KeyActionTabs;
